import { render, staticRenderFns } from "./Mirrors.vue?vue&type=template&id=6aecdfd2&scoped=true&"
import script from "./Mirrors.vue?vue&type=script&lang=js&"
export * from "./Mirrors.vue?vue&type=script&lang=js&"
import style0 from "./Mirrors.vue?vue&type=style&index=0&id=6aecdfd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aecdfd2",
  null
  
)

export default component.exports